import { render } from "./MenuRole.vue?vue&type=template&id=0ea8bb4c&ts=true"
import script from "./MenuRole.vue?vue&type=script&lang=ts"
export * from "./MenuRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__